import React from 'react';
import Generic from './Generic';

interface NumberProps extends React.HTMLAttributes<HTMLDivElement> {
  align?: 'right' | 'left';
  value: number;
}
const NumberCell: React.FC<NumberProps> = ({ value, align = 'right', ...props }) => {
  return <Generic value={value} align={align} {...props} />;
};

export default NumberCell;
